import React from "react";

import "./src/scss/style.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { PreferencesProvider } from "./src/contexts/PreferencesContext";
import { captureAttribution } from "./src/helpers/attribution";

// Snapshot first-touch acquisition params (utm/gclid/...) once per session — the
// enquiry form attaches them to the CRM lead payload (src/helpers/attribution.js).
export const onClientEntry = () => {
  captureAttribution();
};

// Wrap the whole app once so the currency/unit preference persists across navigation.
export const wrapRootElement = ({ element }) => (
  <PreferencesProvider>{element}</PreferencesProvider>
);
